<!-- External link -->
<div *ngIf="block && !isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(objTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(objTitle.link).queryParams" class="container-faq bg-neutral-A1 position-relative cursor-pointer no-print" 
    [ngClass]="margin !== '' ? margin : 'm-3'"
    [ngClass]="{'hover-effect': objTitle.link}">
    <div class="container-faq__badge position-absolute bg-brand-90">
        <p class="m-0 ls-label-small-semibold text-brand-40 text-uppercase" [innerHTML]="badgeText"></p>
    </div>
    <div class="container-faq__category d-flex flex-column justify-content-between h-100">
        <p *ngIf="block.field_tassonomia_area_universita"
            class="container-faq__category__taxonomy ls-label-small-semibold text-neutral-60 text-uppercase"
            [innerHTML]="setLabelCategorySmall(block.field_tassonomia_area_universita)"></p>
        <h3 *ngIf="objTitle" class="ls-h3-item-title-small" [innerHTML]="objTitle.title"></h3>
    </div>
</div>
<!-- END External link -->
<!-- Internal link -->
<a *ngIf="block && isLinkEsternal" [href]="objTitle.link" class="no-print">
    <div class="container-faq bg-neutral-A1 position-relative" 
    [ngClass]="margin !== '' ? margin : 'm-3'"
    [ngClass]="{'hover-effect': objTitle.link}">
    <div class="container-faq__badge position-absolute bg-brand-90">
        <p class="m-0 ls-label-small-semibold text-brand-40 text-uppercase" [innerHTML]="badgeText"></p>
    </div>
    <div class="container-faq__category d-flex flex-column justify-content-between h-100">
        <p *ngIf="block.field_tassonomia_area_universita"
            class="container-faq__category__taxonomy ls-label-small-semibold text-neutral-60 text-uppercase"
            [innerHTML]="setLabelCategorySmall(block.field_tassonomia_area_universita)"></p>
        <h3 *ngIf="objTitle" class="ls-h3-item-title-small" [innerHTML]="objTitle.title"></h3>
    </div>
</div>
</a>
<!-- END Internal link -->
<app-sample-print 
    [taxonomy]="block.field_tassonomia_area_universita ? setLabelCategorySmall(block.field_tassonomia_area_universita) : ''"
    [title]="objTitle.title">
</app-sample-print>